import React, {PropsWithChildren, ReactNode} from "react";
import classNames from "classnames";

import {CardCoverImageWithText} from "./covers/CardCoverWithText";
import {CardBadge} from "./CardBadge";

import {cardWrapperStyle} from "./Card.module.css";

interface IProps {
    className?: string;
    badge?: ReactNode;
    href?: string;
    target?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const Card = (props: PropsWithChildren<IProps>) => {
    const cardContent = (
        <>
            {props.badge ? <CardBadge>{props.badge}</CardBadge> : null}

            {props.children}
        </>
    );

    const cardWrapperCN = classNames(props.className, cardWrapperStyle);

    return props.href ? (
        <a href={props.href} className={cardWrapperCN} target={props.target} onClick={props.onClick}>
            {cardContent}
        </a>
    ) : (
        <div className={cardWrapperCN} onClick={props.onClick}>
            {cardContent}
        </div>
    );
};

Card.CoverImageWithText = CardCoverImageWithText;
import React, {PropsWithChildren, ReactNode} from "react";
import classNames from "classnames";

import {CardCoverImageWithText} from "./covers/CardCoverWithText";
import {CardBadge} from "./CardBadge";

import {cardWrapperStyle} from "./Card.module.css";

interface IProps {
    className?: string;
    badge?: ReactNode;
    href?: string;
    target?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const Card = (props: PropsWithChildren<IProps>) => {
    const cardContent = (
        <>
            {props.badge ? <CardBadge>{props.badge}</CardBadge> : null}

            {props.children}
        </>
    );

    const cardWrapperCN = classNames(props.className, cardWrapperStyle);

    return props.href ? (
        <a href={props.href} className={cardWrapperCN} target={props.target} onClick={props.onClick}>
            {cardContent}
        </a>
    ) : (
        <div className={cardWrapperCN} onClick={props.onClick}>
            {cardContent}
        </div>
    );
};

Card.CoverImageWithText = CardCoverImageWithText;
